import styled from 'styled-components';

const ModalMainWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: min(500px, calc(100vw - 32px));
  box-sizing: border-box;
  background: ${(p) => p.theme.colors.light};
  padding: 30px clamp(16px, 5vw, 50px);
  border-radius: 15px 15px 15px 0px;
  overflow: hidden;
  .event-modal-body {
    max-height: calc(100vh - 120px);
    overflow-y: auto;
    overscroll-behavior: contain;
    scrollbar-gutter: stable;
    overflow-wrap: anywhere;
  }
  button {
    height: auto;
    min-height: 44px;
    white-space: normal;
    line-height: 1.5;
    max-width: 100%;
  }
  button:focus-visible { outline: 3px solid #0b319d; outline-offset: 2px; }

  .closeBtn {
    position: absolute;
    right: 10px;
    top: 10px;
    font-size: 20px;
    cursor: pointer;
  }
`;

const Row = styled.div`
  margin-top: 15px;
  display: flex;
  gap: 10px;
  min-width: 0;
  & > :last-child { min-width: 0; }
  .icon { flex-shrink: 0; }

  .copy {
    cursor: pointer;
  }
`;

const ActionBtns = styled.div`
  display: flex;
  gap: 30px;
  flex-wrap: wrap;
  margin-top: 40px;

  button {
    font-family: 'Roboto';
    font-size: ${(p) => p.theme.fontSizes.base};
    line-height: 19px;
    text-decoration-line: underline;
    color: ${(p) => p.theme.colors.secondary500};
    cursor: pointer;
  }
`;

const ConfirmWrapper = styled.div`
  font-family: 'Roboto';
  font-weight: 400;
  font-size: ${(p) => p.theme.fontSizes.base};
  line-height: 20px;
  text-align: center;
  color: ${(p) => p.theme.colors.gray500};
`;

const ConfirmTitle = styled.div`
  font-weight: 700;
  margin-bottom: 30px;
`;

const DeleteBtns = styled.div`
  display: flex;
  justify-content: center;
  gap: 40px;
  margin-top: 50px;

  button:last-child {
    color: ${(p) => p.theme.colors.primary100};
    text-decoration-line: underline;
    cursor: pointer;
  }
`;

export {
    ModalMainWrapper,
    Row,
    ActionBtns,
    ConfirmWrapper,
    ConfirmTitle,
    DeleteBtns
}
